module.exports = __webpack_public_path__ + "static/media/artBioPetri.8e22e817.jpg";